import {API} from '@/utils/api'
import {findIndex} from 'lodash'

export default {

  setActive(context, account) {
    context.commit('setActive', account)
  },

  add(context, account) {
    context.commit('add', account)
    context.commit('setActive', context.state.list.length - 1)

    context.dispatch('loadComments', {account, type: 'communication'})
    context.dispatch('loadComments', {account, type: 'kyc'})
    context.dispatch('loadComments', {account, type: 'ticket'})
    context.dispatch('loadComments', {account, type: 'vip'})
    context.dispatch('loadTasks', {account})
    context.dispatch('loadDuplicates', {account})
    context.dispatch('loadTotalOpenBets', account)
    context.dispatch('loadKYC', {account})
    context.dispatch('loadAutomaticKYC', account)
    context.dispatch('loadRecentTransactions', account)
    context.dispatch('loadIovation', account)
    context.dispatch('loadLimits', account)
    context.dispatch('loadPaymethods', account)
    context.dispatch('loadOAuth', {account})
    context.dispatch('loadTrueplay', {account})
    context.loadRecentTransactions(context, account)
  },

  load(context, params) {
    return API.call('/$v/account/info.json', {
      value: params.login,
      account_id: params.account_id
    }, {login: params.login})
  },

  get_balance(context, params) {
    return API.call('/$v/account/get_balance.json', {
      value: params.login,
      account_id: params.account_id
    }, {login: params.login})
  },

  loadComments(context, params) {
    const index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].comments.loading = true
    API.call('/$v/account/comments/list.json', {
      type: params.type,
      login: params.account.login,
      account_id: params.account.account_id
    }, params.account).then(resp => resp.data).then(r => {
      context.commit('setComments', {type: params.type, items: r, ...params})
      context.state.list[index].comments.loading = false
    })
  },

  loadKYC(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].kyc.documents.loading = true
    API.call('/$v/account/kyc/get.json', {
      login: params.account.login,
      account_id: params.account.account_id
    }, params.account).then(resp => resp.data).then(r => {
      context.commit('setDocuments', {items: r.documents, summary: r.summary, index, ...params})
      context.commit('setKYC', {kyc: r.account.kyc, data: r.account.data, index, ...params})
      context.state.list[index].kyc.documents.loading = false
    })
  },

  loadOAuth(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].oauth.loading = true
    API.call('/$v/account/oauth/list.json', {
      login: params.account.login,
      account_id: params.account.account_id
    }, params.account).then(resp => resp.data).then(r => {
      context.commit('setOAuth', {items: r, index})
      context.state.list[index].oauth.loading = false
    })
  },

  loadTrueplay(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].trueplay.loading = true
    API.call('/$v/account/trueplay/balance.json', {
      login: params.account.login,
      account_id: params.account.account_id,
    }, params.account).then(r => r.data)
      .then(data => {
        context.commit('setTrueplay', {data, index})
      })
      .finally(() => context.state.list[index].trueplay.loading = false)
  },

  loadIovation(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account_id})

    context.state.list[index].iovation.loading = true
    API.call('/$v/account/iovation.json', {
      login: params.login
    }, params).then(resp => resp.data).then(r => {
      context.commit('setIovation', {items: r, index})
    }).finally(() => {
      context.state.list[index].iovation.loading = false
    })
  },

  loadLimits(context, params) {

    if (!this.state.auth.checkAccess({key: 'limits', value: true})) {
      return []
    }

    let index = findIndex(context.state.list, {account_id: params.account_id})

    context.state.list[index].limits.loading = true
    API.call('/$v/account/limits/list.json', {
      account_id: params.account_id,
      login: params.login
    }, params).then(resp => resp.data).then(r => {
      context.commit('setLimits', {items: r, index})
    }).finally(() => {
      context.state.list[index].limits.loading = false
    })
  },

  loadRecentTransactions(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].recentTransactions.loading = true

    return API.call('/$v/account/finance/list.json', {
      login: account.login,
      account_id: account.account_id,
      options: context.state.list[index].recentTransactions.options,
    }, account).then(resp => {
      context.commit('setRecentTransactions', resp)
      return resp.data
    }).finally(() => {
      context.state.list[index].recentTransactions.loading = false
    })
  },

  loadDuplicates(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].duplicates.loading = true
    context.state.list[index].duplicates.items = []

    return API.call('/$v/account/duplicates.json', {
      login: params.account.login,
      account_id: params.account.account_id,
      options: context.state.list[index].duplicates.tableOptions,
    }, params.account).then(resp => {
      context.commit('setDuplicates', resp)
      return resp.data
    }).finally(() => {
      context.state.list[index].duplicates.loading = false
    })
  },

  loadPaymethods(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account_id})

    context.state.list[index].paymethods.loading = true
    context.state.list[index].paymethods.items = []

    return API.call('/$v/paymethod/name_list.json', {whitelisted: true}, params).then(resp => {
      context.commit('setPaymethodsWhitelist', resp.data)
      context.commit('sortPaymethodsWhitelist')
      return resp.data
    }).finally(() => {
      context.state.list[index].paymethods.loading = false
    })
  },

  loadFinance(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].finance.loading = true

    context.commit('setFinance', {items: [], index, total: context.state.list[index].finance.totalItems})
    return API.call('/$v/account/finance/list.json', {
      deposit_rollover: 1,
      with_time: true,
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].finance.from + ' ' + (context.state.list[index].finance.fromTime || '00:00:00'),
      to: context.state.list[index].finance.to + ' ' + (context.state.list[index].finance.toTime || '23:59:59'),
      options: context.state.list[index].finance.tableOptions,
      filters: context.state.list[index].finance.filters

    }, account).then(resp => {
      context.commit('setFinance', {items: resp.data, index, total: resp.total})
      return resp.data
    }).finally(() => {
      context.state.list[index].finance.loading = false
    })
  },

  loadAutomaticKYC(context, account) {

    if (!this.state.auth.checkAccess({key: 'document_link', value: true})) {
      return []
    }

    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].kyc.automatic.loading = true

    context.commit('setAutomaticKYC', {items: [], index})
    return API.call('/$v/account/kyc/list.json', {
      login: account.login,
      account_id: account.account_id,
    }, account).then(resp => {
      context.commit('setAutomaticKYC', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].kyc.automatic.loading = false
    })
  },

  loadGameHistory(context, account) {

    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].gameHistory.loading = true

    return API.call('/$v/account/game_history/list.json', {
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].gameHistory.from + ' ' + (context.state.list[index].gameHistory.fromTime || '00:00:00'),
      to: context.state.list[index].gameHistory.to + ' ' + (context.state.list[index].gameHistory.toTime || '23:59:59')
    }, account).then(resp => {
      context.commit('setGameHistory', {items: resp.data, totalRows: resp.totalRows, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].gameHistory.loading = false
    })

  },

  loadTotalOpenBets(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    return API.call('/$v/account/sport_history/total_open_bets.json', {
      login: account.login,
      account_id: account.account_id,
    }, account).then(resp => {
      context.state.list[index].totalOpenBets.amount = parseFloat(resp.data.totalOpenBets);
      return resp.data
    })
  },

  loadSportHistory(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].sportHistory.loading = true

    return API.call('/$v/account/sport_history/list.json', {
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].sportHistory.from + ' ' + (context.state.list[index].sportHistory.fromTime || '00:00:00'),
      to: context.state.list[index].sportHistory.to + ' ' + (context.state.list[index].sportHistory.toTime || '23:59:59')
    }, account).then(resp => {
      context.commit('setSportHistory', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].sportHistory.loading = false
    })

  },

  loadBonuses(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].bonus.loading = true

    return API.call('/$v/account/bonus/list.json', {
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].bonus.from,
      to: context.state.list[index].bonus.to
    }, account).then(resp => {
      context.commit('setBonuses', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].bonus.loading = false
    })

  },

  loadPackages(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].packages.loading = true

    return API.call('/$v/account/bonus/packages_list.json', {
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].packages.from,
      to: context.state.list[index].packages.to
    }, account).then(resp => {
      context.commit('setPackages', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].packages.loading = false
    })

  },

  loadShop(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].shop.loading = true

    return API.call('/$v/account/bonus/shop.json', {
      login: account.login,
      account_id: account.account_id,
      from: context.state.list[index].shop.from,
      to: context.state.list[index].shop.to
    }, account).then(resp => {
      context.commit('setShop', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].shop.loading = false
    })

  },

  loadBenefits(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})

    context.state.list[index].benefits.loading = true

    return API.call('/$v/account/bonus/available.json', {
      login: account.login,
      account_id: account.account_id,
    }, account).then(resp => {
      context.commit('setBenefits', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].benefits.loading = false
    })

  },

  loadStats(context, account) {
    let index = findIndex(context.state.list, {account_id: account.account_id})
    context.state.list[index].stats.loading = true

    let action = 'list'

    return API.call(`/$v/account/stats/${action}.json`, {
      login: account.login,
      account_id: account.account_id,
      type: context.state.list[index].stats.type,
      from: context.state.list[index].stats.from,
      to: context.state.list[index].stats.to
    }, account).then(resp => {
      context.commit('setStats', {items: resp.data, index})

      context.state.list[index].stats.current_type = context.state.list[index].stats.type

      return resp.data
    }).finally(() => {
      context.state.list[index].stats.loading = false
    })

  },

  loadTasks(context, params) {
    if (!this.state.auth.checkAccess({key: 'task_view', value: true})) {
      return []
    }

    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].tasks.loading = true
    context.state.list[index].tasks.items = []

    return API.call('/$v/task/list.json', {
      account_id: params.account.account_id,
    }, params.account).then(resp => {
      context.commit('setTasks', {items: resp.data, index})
      return resp.data
    }).finally(() => {
      context.state.list[index].tasks.loading = false
    })
  },

  deleteTask(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].tasks.loading = true

    return API.call('/$v/task/delete.json', {
      id: params.task_id
    }).then(() => context.dispatch('loadTasks', params))
  },

  updateTask(context, params) {
    let index = findIndex(context.state.list, {account_id: params.account.account_id})

    context.state.list[index].tasks.loading = true

    return API.call('/$v/task/update.json', {
      task: params.task,
    })
      .then(() => context.dispatch('loadTasks', params))
      .catch(() => {
        context.state.list[index].tasks.loading = false
      })
  },

  remove(context, account) {
    context.commit('remove', account)
  },

  removeAll(context) {
    context.commit('removeAll')
  },

}
